import { Link } from 'react-router-dom'
import { fg } from '../copyFeatGrowth'
import { useFlag } from '../lib/flags'
import { ChevronRight } from '../ui/icons'

/** An optional door on Browse to the taste interview (features 10/16, flag taste_space). Browse.tsx mounts it with one line. */
export function TasteEntry() {
  if (!useFlag('taste_space')) return null
  return (
    <Link to="/taste?v=interview" data-review-id="taste-entry"
      className="press t-control mt-3 inline-flex min-h-11 items-center gap-1 text-accent-ink underline-offset-4 hover:underline">
      {fg('fg.taste_entry')}<ChevronRight size={18} className="shrink-0" />
    </Link>
  )
}
